import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/UI/Button';
export const BibiEnejeSpotlight = () => {
  return <div className="pt-20 bg-white min-h-screen" data-id="element-1044">
      <section className="relative py-16 border-b border-gray-200" data-id="element-1045">
        <div className="absolute inset-0 z-0" data-id="element-1046">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iAnbjCZ3t34HT1XWLnohD6/Bibi_Eneje_The_Networking_Salon_Spotlight.png" alt="Bibi Eneje" className="w-full h-full object-cover grayscale" data-id="element-1047" />
          <div className="absolute inset-0 bg-black bg-opacity-60" data-id="element-1048"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-1049">
          <div className="max-w-4xl mx-auto" data-id="element-1050">
            <Link to="/salon-spotlight" className="inline-flex items-center text-white hover:text-gray-200 mb-6" data-id="element-1051">
              <ArrowLeft size={20} className="mr-2" data-id="element-1052" />
              Back to Salon Spotlight
            </Link>
            <div className="text-white" data-id="element-1053">
              <p className="text-sm mb-4" data-id="element-1054">SALON SPOTLIGHT</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-1055">
                Bibi Eneje
              </h1>
              <p className="text-2xl md:text-3xl font-medium" data-id="element-1056">
                Architect of Influence. Builder of Ecosystems. Champion of
                Clarity.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-1057">
        <div className="container mx-auto px-4" data-id="element-1058">
          <div className="max-w-4xl mx-auto" data-id="element-1059">
            <article className="prose prose-lg max-w-none" data-id="element-1060">
              <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-1061">
                Every community has people whose presence doesn't just add
                energy—they elevate the room. In The Networking Salon, Bibi
                Eneje is one of those rare catalysts. An entrepreneur,
                communications advisor, and nation builder, Bibi moves through
                the world with a quiet intensity that turns ideas into structure
                and vision into cultural momentum.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1062">
                As Founder and Lead Strategist at Kora & Hive Communications,
                she designs influence with intention—helping African leaders
                show up with clarity, credibility, and confidence. Through The
                Work Haven, she curates spaces where creators and founders meet,
                collaborate, and grow, building ecosystems that strengthen the
                fabric of innovation across the continent. She mentors at
                Morpheus Academy, co-leads community projects like The Table and
                RETRO, and continues to shape culture through the rooms she
                creates and the people she empowers.
              </p>
              <div className="my-12" data-id="element-1063">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a1cmPsUKCWVvANEm2rKKvj/IMG_6994.png" alt="Bibi Eneje portrait" className="w-full max-w-2xl mx-auto rounded-lg border-2 border-gray-300" loading="lazy" data-id="element-1064" />
              </div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-1065">
                Her Story: A Calling Shaped by Storytelling
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1066">
                Bibi's journey began with a simple truth: stories shape what
                people believe is possible. Starting out as a features writer,
                she discovered that the most powerful ideas often lacked
                visibility. Her work became a way of correcting that
                imbalance—giving voice to remarkable projects and the people
                behind them.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1067">
                At Kora & Hive, she builds communication systems that earn
                trust. At The Work Haven, she and her team crafted a space where
                creators don't just work—they grow. Behind it all is her mission
                to help people find their voice and give that voice room to
                build something real.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-1068">
                Culture, Community, and Impact
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1069">
                Bibi believes culture is shaped in the rooms where people feel
                seen, heard, and understood. Her work—whether through curated
                communities, storytelling systems, or intentional
                teaching—creates those rooms.
              </p>
              <div className="my-12" data-id="element-1070">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cVfpQEfSVn8mT6V81pCzxx/IMG_6996.png" alt="Bibi Eneje" className="w-full max-w-2xl mx-auto rounded-lg border-2 border-gray-300" loading="lazy" data-id="element-1071" />
              </div>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1072">
                The Work Haven thrives on community, collaboration, and growth.
                The Table nurtures a network of publicists raising the standard
                for communication across Africa. RETRO invites women to lead
                boldly, reminding them that influence expands when we do.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1073">
                Her north star is simple: help people think clearer, act braver,
                and lead with confidence. Every piece of feedback, every shift
                in someone's clarity or courage, reassures her that the work
                matters.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-1074">
                What She's Building Next
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1075">
                Bibi is drawn to collaborations at the intersection of
                storytelling, culture, and national impact. She is open to
                projects with cultural institutions, tourism boards, and
                development organizations shaping perception and policy across
                Africa. Editorial and thought-leadership collaborations also sit
                at the top of her creative pursuits.
              </p>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1076">
                Her influences are leaders who turn authority into
                participation—those who see power as something to circulate. And
                her advice to young builders is a gentle but firm compass: Start
                with clarity. Learn your craft deeply. Build slowly and in
                community. And when you rise, make room for others.
              </p>
              <h2 className="text-3xl font-bold text-gray-800 mb-6 mt-12" data-id="element-1077">
                Why We Celebrate Her
              </h2>
              <p className="text-gray-700 leading-relaxed mb-8" data-id="element-1078">
                In The Networking Salon, Bibi has been a strategic
                ally—supportive, present, thoughtful, and deeply invested in
                growth. She embodies the spirit of this ecosystem: intentional
                connection, generous service, and leadership that multiplies
                opportunity.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed font-medium italic border-l-4 border-gray-300 pl-6 my-12" data-id="element-1079">
                Bibi, thank you for shaping culture with clarity, courage, and
                heart. Your work reminds us that influence is not loud—it is
                deeply understood.
              </p>
            </article>
            <div className="mt-16 pt-8 border-t-2 border-gray-300" data-id="element-1080">
              <Link to="/salon-spotlight" data-id="element-1081">
                <Button variant="outline" data-id="element-1082">
                  <ArrowLeft size={20} className="mr-2" data-id="element-1083" />
                  Back to Salon Spotlight
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};